export default "__VITE_PUBLIC_ASSET__d2072ad4__"